import React, { useState } from 'react';
import { faPrint, faPaperclip } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import HoverImage from 'react-hover-image/build';
import moment from 'moment';
import {
  Button,
  Input,
  Col,
  Row,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from 'reactstrap';
import Drawer from 'components/Drawer';
import FaxPopup from 'components/FaxPopup';
import AlertModal from 'components/AlertModal';
import AttachIcon from 'assets/icon/icon-icon-options-attachment.svg';
import AttachHoverIcon from 'assets/icon/icon-icon-options-attachment_hover.svg';
import Comments from '../../common/Comments';

const PatientDetails = ({ disabled, data }) => {
  const [faxPopup, setFaxPopup] = useState(false);
  const [modal, setModal] = useState(false);
  const [isOpen, setOpen] = useState(false);
  const [file, setFile] = useState('');
  const { patientFirstName, patientLastName, patientDOB, medicalRecordNumber } =
    data;

  const modalToggle = () => setModal(!modal);

  const toggleDrawer = () => {
    console.log('error');
    setOpen(!isOpen);
  };
  const handleFax = () => {
    setFaxPopup((pre) => !pre);
  };

  const onHandleFileChange = (e) => {
    const file = e.target.files[0];
    setFile(file);
  };

  return (
    <>
      <Row>
        <Col md='11'>
          <Row className='align-items-center'>
            <Col md='auto' className='pe-3'>
              <p className='f-14 mb-0'>
                First Name:
                <b className='d-inline-block ps-2 font-weight-500'>
                  {patientFirstName || '-'}
                </b>
              </p>
            </Col>
            <Col md='auto' className='pe-3'>
              <p className='f-14 mb-0'>
                Last Name:
                <b className='d-inline-block ps-2 font-weight-500'>
                  {patientLastName || '-'}
                </b>
              </p>
            </Col>
            <Col md='auto' className='pe-3'>
              <p className='f-14 mb-0'>
                DOB:
                <b className='d-inline-block ps-2 font-weight-500'>
                  {patientDOB ? moment(patientDOB).format('MM/DD/YYYY') : '-'}
                </b>
              </p>
            </Col>
            <Col md='auto' className='pe-3'>
              <p className='f-14 mb-0'>
                Medical Record Number:
                <b className='d-inline-block ps-2 font-weight-500'>
                  {medicalRecordNumber || '-'}
                </b>
              </p>
            </Col>
            <Col className='my-auto'>
              <div className='d-flex align-items-center'>
                <p className='f-14 mb-0 f-inline-block'>
                  Add Attachment(Patient):
                </p>

                {!file && (
                  <Button
                    color='link'
                    className='ps-2 text-primary font-weight-500 py-0'
                    onClick={toggleDrawer}
                    disabled={disabled}
                  >
                    <HoverImage
                      src={AttachIcon}
                      hoverSrc={AttachHoverIcon}
                      alt=''
                    />{' '}
                    Attach
                  </Button>
                )}
                {file && (
                  <div className='d-flex align-items-center'>
                    <label htmlFor='filePatient' className='cursor-pointer m-0'>
                      {' '}
                      <FontAwesomeIcon icon={faPaperclip} color='#555C6B' />
                    </label>
                    <Input
                      type='file'
                      id='filePatient'
                      className='d-none'
                      accept='application/pdf'
                      onChange={onHandleFileChange}
                    />
                    <p className='font-size-14 mb-0'>{file.name}</p>
                    <Button
                      color='link color-pink text-decoration-none'
                      className='py-0'
                    >
                      <span className='font-size-14'>View Attachment</span>
                    </Button>
                  </div>
                )}
              </div>
            </Col>
          </Row>
        </Col>
        <Col className='d-flex align-items-center justify-content-end'>
          {false && (
            <div className='d-flex align-items-center'>
              <Button
                color='secondry'
                onClick={handleFax}
                size='sm'
                className='me-3'
                disabled={true}
              >
                <FontAwesomeIcon icon={faPrint} className='me-2' />
                Fax
              </Button>
              <UncontrolledDropdown group>
                <Button color='success' size='sm' outline>
                  APPROVED
                </Button>
                <DropdownToggle
                  className='custom-dropdown'
                  caret
                  color='success'
                  size='sm'
                  outline
                />
                <DropdownMenu className='border-0 p-1 status-dropdown'>
                  <DropdownItem>Approved</DropdownItem>
                  <DropdownItem onClick={modalToggle}>Replenished</DropdownItem>
                </DropdownMenu>
              </UncontrolledDropdown>
            </div>
          )}
        </Col>
      </Row>
      {faxPopup && (
        <div className='top-fax'>
          <FaxPopup handleFax={handleFax} />
        </div>
      )}
      <AlertModal
        toggle={modalToggle}
        isOpen={modal}
        message='Do you want to change the status from Approved to Replenished?'
      />
      <Drawer
        direction='end'
        isOpen={isOpen}
        toggle={toggleDrawer}
        title='Add Patient Comment'
      >
        <Comments onClose={toggleDrawer} />
      </Drawer>
    </>
  );
};

export default PatientDetails;
